import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Gestionnaire d'erreur global pour ignorer les erreurs MetaMask et autres avertissements non critiques
window.addEventListener('error', (event) => {
  // Ignorer les erreurs provenant de l'extension MetaMask
  if (
    event.message?.includes('MetaMask') ||
    event.message?.includes('Failed to connect to MetaMask') ||
    event.filename?.includes('nkbihfbeogaeaoehlefnkodbefgpgknn') ||
    event.filename?.includes('chrome-extension')
  ) {
    event.preventDefault();
    console.warn('⚠️ Erreur MetaMask ignorée (extension de navigateur):', event.message);
    return true;
  }
  
  // Ignorer l'avertissement "ES Removing unpermitted intrinsics" (non critique, provenant de bibliothèques tierces)
  if (event.message?.includes('Removing unpermitted intrinsics') || 
      event.message?.includes('unpermitted intrinsics')) {
    event.preventDefault();
    // Ne pas logger pour éviter le bruit dans la console
    return true;
  }
  
  return false;
});

// Gestionnaire pour les promesses rejetées non gérées
window.addEventListener('unhandledrejection', (event) => {
  // Ignorer les erreurs MetaMask dans les promesses
  if (
    event.reason?.message?.includes('MetaMask') ||
    event.reason?.message?.includes('Failed to connect to MetaMask')
  ) {
    event.preventDefault();
    console.warn('⚠️ Erreur MetaMask ignorée (promesse rejetée):', event.reason?.message);
    return true;
  }
  return false;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Worker PWA DÉSACTIVÉ - Cause des erreurs 502 sur les requêtes API
// Le service worker interceptait les requêtes API même avec les vérifications
// Solution : Désactiver complètement le service worker pour éviter les problèmes
if ('serviceWorker' in navigator) {
  // Désactiver tous les service workers existants immédiatement
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then(() => {});
    }
  });
  
  // Empêcher l'enregistrement de nouveaux service workers
  window.addEventListener('load', () => {
    // Ne rien faire - service worker complètement désactivé
  });
}
